// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d059f8e45ae9{background-color:#fff;border-radius:5px;box-shadow:0px 5px 25px rgba(15,16,17,.07)}._341d248f9b39{padding:16px 30px}.dd34a3f39aa5 ._341d248f9b39{padding:30px 40px}", "",{"version":3,"sources":["webpack://./src/styles/components/card.scss"],"names":[],"mappings":"AAAA,cAEI,qBAAA,CACA,iBAAA,CACA,0CAAA,CAEA,eAEI,iBAAA,CAGJ,6BACI,iBAAA","sourcesContent":[".card{\n\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0px 5px 25px rgba(15, 16, 17, 0.07);\n\n    &__body{\n\n        padding: 16px 30px;\n    }\n    \n    &--default &__body{\n        padding: 30px 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "d059f8e45ae9",
	"card__body": "_341d248f9b39",
	"card--default": "dd34a3f39aa5"
};
export default ___CSS_LOADER_EXPORT___;
